// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"143":"app","535":"login"}[chunkId] || chunkId) + ".bundle.js";
};